<template>
  <div class="form-edit-page">
    <div class="page-header">
      <div>
        <h2>Processos Administrativos</h2>
        <p class="page-subtitle">
          Controle de autos, penalidades e andamentos processuais
        </p>
      </div>

      <button class="btn-primary" @click="$emit('novo-processo')">
        + Novo Processo
      </button>
    </div>

    <div class="filter-card">
      <div class="row">
        <div class="form-item">
          <label>Buscar</label>
          <input
            v-model="filtro"
            placeholder="Nº processo, estabelecimento ou fiscal..."
          />
        </div>

        <div class="form-item">
          <label>Tipo</label>
          <select v-model="tipoFiltro">
            <option value="">Todos</option>
            <option v-for="tipo in tipos" :key="tipo" :value="tipo">
              {{ tipo }}
            </option>
          </select>
        </div>

        <div class="form-item">
          <label>Situação</label>
          <select v-model="status">
            <option value="">Todas</option>
            <option>ABERTO</option>
            <option>EM ANDAMENTO</option>
            <option>ENCERRADO</option>
          </select>
        </div>
      </div>
    </div>

    <div class="table-card">
      <table class="table-default">
        <thead>
          <tr>
            <th>Nº Processo</th>
            <th>Tipo</th>
            <th>Estabelecimento</th>
            <th>Data</th>
            <th>Situação</th>
            <th>Fase Atual</th>
            <th>Próximo Andamento</th>
            <th style="width: 160px">Ações</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="p in listaFiltrada" :key="p.id" class="row-clickable">
            <td>{{ p.numero }}</td>
            <td>{{ p.tipo }}</td>
            <td>{{ p.estabelecimento }}</td>
            <td>{{ formatarData(p.data) }}</td>
            <td>
              <span class="badge" :class="badgeClass(p.situacao)">
                {{ p.situacao }}
              </span>
            </td>
            <td>{{ p.faseAtual }}</td>
            <td>{{ p.proximoAndamento || '-' }}</td>
            <td>
              <div class="table-actions">
                <button class="btn-secondary" @click="$emit('abrir', p)">
                  Abrir
                </button>
                <button class="btn-primary" @click="$emit('movimentar', p)">
                  Movimentar
                </button>
              </div>
            </td>
          </tr>

          <tr v-if="!listaFiltrada.length">
            <td colspan="8" class="empty-cell">
              Nenhum processo encontrado para os filtros informados.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

defineEmits(['novo-processo', 'abrir', 'movimentar'])

const filtro = ref('')
const tipoFiltro = ref('')
const status = ref('')

const tipos = [
  'AUTO DE INTIMAÇÃO',
  'AUTO DE INFRAÇÃO',
  'MULTA',
  'ADVERTÊNCIA',
  'INTERDIÇÃO',
  'DESINTERDIÇÃO',
  'SUSPENSÃO',
  'APREENSÃO',
  'FIEL DEPOSITÁRIO',
  'DOAÇÃO'
]

const lista = ref([
  {
    id: 1,
    numero: 'PROC-2026-0001',
    tipo: 'AUTO DE INFRAÇÃO',
    estabelecimento: 'Frigorífico Sul',
    data: '2026-03-01',
    situacao: 'EM ANDAMENTO',
    faseAtual: 'PRAZO PARA DEFESA',
    proximoAndamento: 'ANÁLISE DA DEFESA',
    fiscal: 'Carlos'
  },
  {
    id: 2,
    numero: 'PROC-2026-0002',
    tipo: 'INTERDIÇÃO',
    estabelecimento: 'Laticínio Vale',
    data: '2026-03-05',
    situacao: 'ABERTO',
    faseAtual: 'CIÊNCIA DO ESTABELECIMENTO',
    proximoAndamento: 'BLOQUEIO DAS ATIVIDADES',
    fiscal: 'Marina'
  }
])

const listaFiltrada = computed(() => {
  return lista.value.filter(p => {
    const texto = `${p.numero} ${p.estabelecimento} ${p.fiscal}`.toLowerCase()

    return (
      (!filtro.value || texto.includes(filtro.value.toLowerCase())) &&
      (!tipoFiltro.value || p.tipo === tipoFiltro.value) &&
      (!status.value || p.situacao === status.value)
    )
  })
})

function formatarData(data) {
  if (!data) return ''
  const [ano, mes, dia] = data.split('-')
  return `${dia}/${mes}/${ano}`
}

function badgeClass(situacao) {
  if (situacao === 'ABERTO') return 'badge-open'
  if (situacao === 'EM ANDAMENTO') return 'badge-progress'
  if (situacao === 'ENCERRADO') return 'badge-closed'
  return ''
}
</script>